import { Box, Typography } from '@mui/material'
import React from 'react'
import ManufacturingImg from '../../assets/ManufacturingImg.png'

function Manufacturing() {
    return (
        <Box sx={{ backgroundColor: '#F9FBFC', width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
            <Box sx={{ width: { xs: '100%', sm: '50%' }, padding: '20px' }}>
                <img src={ManufacturingImg} alt="Manufacturing" style={{ width: '85%', height: 'auto' }} />
            </Box>
            <Box sx={{ width: { xs: '90%', sm: '35%' }, display: 'flex', flexDirection: 'column', mt: { xs: '0%', sm: '10%' }, padding: '20px' }}>
                <Typography sx={{ color: '#00BFA5', fontFamily: 'poppins', fontSize: '20px' }}>Can Benefit</Typography>
                <Typography sx={{ fontWeight: 'bold', fontSize: '30px' }}>Manufacturing & processing Units</Typography>
                <Typography sx={{ fontSize: '15px', fontFamily: 'Sora', color: '#6C87AE' }}>
                    Managing inventory can be overwhelming, but with our intelligent system, you can streamline your operations, reduce costs, and improve efficiency. Whether you're a small business or an enterprise, our software adapts to your needs, ensuring real-time control over your stock.
                </Typography>
            </Box>
        </Box>
    )
}

export default Manufacturing